export const INSTITUTION = {
    COMMUNITY_STANDPOST: 'Community standpost',
    SCHOOL: 'School',
    TEMPLE: 'Temple',
    HOSPITAL: 'Hospital'
}